import * as React from 'react'

import {
  i18n,
  useSiteConfig,
  useSiteDefinition,
} from '@thg-commerce/enterprise-core'
import { ProductPageData } from '@thg-commerce/enterprise-network/src/ApolloProvider/resolvers/Query/Product/ProductPage'
import { useTheme } from '@thg-commerce/enterprise-pages/src/Product/theme'
import { spacing } from '@thg-commerce/enterprise-theme'

import { useProductPage } from '../../context'

import { ProductLaunchDateText, ProductStockInformationText } from './styles'

const formatPreorderReleaseDate = (
  launchDateText: string,
  defaultLocale: string,
  preorderReleaseDate?: string,
) => {
  if (!preorderReleaseDate) {
    return null
  }

  const locale = defaultLocale?.replace('_', '-') || 'en-GB'

  const dateFormatOptions: Intl.DateTimeFormatOptions = {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }

  const parsedPreorderReleaseDate = Date.parse(preorderReleaseDate)
  const formatProductLaunchDate = new Date(parsedPreorderReleaseDate)
  const launchDate = new Intl.DateTimeFormat(locale, dateFormatOptions).format(
    formatProductLaunchDate,
  )
  return (
    <ProductLaunchDateText>
      {launchDateText} {launchDate}
    </ProductLaunchDateText>
  )
}

const StockMessageComponent = (props) => {
  const { textStyle, message, selectedVariant, i18nText, defaultLocale } = props
  return (
    <div style={{ marginTop: spacing(2), marginBottom: spacing(2) }}>
      <ProductStockInformationText textStyle={textStyle}>
        {message}
      </ProductStockInformationText>

      {selectedVariant?.product?.preorder &&
        formatPreorderReleaseDate(
          i18nText.launchDateText,
          defaultLocale,
          selectedVariant?.product?.preorderReleaseDate,
        )}
    </div>
  )
}

export const ProductStockInformation = ({}: {
  variants: ProductPageData['variants']
}) => {
  const {
    hasCustomStockMessage,
    showProductStockInformationSoldOut,
  } = useSiteConfig()

  const i18nText = {
    customStockMessage: i18n('product.stock.information.custom'),
    launchDateText: i18n('product.releasedate.text'),
  }
  const { selectedVariant } = useProductPage()
  const { defaultLocale } = useSiteDefinition()

  const availabilityMessageText = selectedVariant?.availabilityMessage || ''

  const hasStockMessage = hasCustomStockMessage || availabilityMessageText
  const showStockMessage =
    hasStockMessage &&
    (selectedVariant?.inStock ||
      (!selectedVariant?.inStock && showProductStockInformationSoldOut))

  const theme = useTheme()

  const textStyle = theme.pageTheme?.productStockInformation?.message?.textStyle

  const message =
    hasCustomStockMessage && i18nText.customStockMessage
      ? i18nText.customStockMessage
      : availabilityMessageText

  return (
    <React.Fragment>
      {showStockMessage && (
        <StockMessageComponent
          textStyle={textStyle}
          message={message}
          selectedVariant={selectedVariant}
          i18nText={i18nText}
          defaultLocale={defaultLocale}
        />
      )}
    </React.Fragment>
  )
}
